import SecondaryButton from './SecondaryButton';

export default SecondaryButton;



// WEBPACK FOOTER //
// ./src/client/Components/SecondaryButton/index.js